import React from 'react'
import { Container, Table, Row, Col, Button, Input, Label, FormGroup } from 'reactstrap'
import { getJobCosts } from '../model/request/jobcost'

function lastMonthRange() {
    const now = new Date()
    const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()
    const month = now.getMonth() === 0 ? 12 : now.getMonth()
    const from = `${year}-${String(month).padStart(2, '0')}-01`
    const lastDay = new Date(year, month, 0).getDate()
    const to = `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
    return { from, to }
}

function formatMoney(val, decimals = 2) {
    if (val == null) return '—'
    return '$' + parseFloat(val).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })
}

class JobCostViewController extends React.Component {

    constructor(props) {
        super(props)
        const { from, to } = lastMonthRange()
        this.state = {
            jobs: [],
            from,
            to,
            jobNameSearch: '',
            customerSearch: '',
            groupByCustomer: false,
            activeGroupByCustomer: false,
        }
        this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidMount() {
        this.handleSearch()
    }

    handleSearch() {
        const { from, to, jobNameSearch, customerSearch, groupByCustomer } = this.state
        this.props.turnOnLoader()
        getJobCosts(from, to, jobNameSearch, customerSearch, groupByCustomer ? 'customer' : undefined).then(
            (result) => {
                this.setState({ jobs: result.data.jobs, activeGroupByCustomer: groupByCustomer })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.turnOffLoader()
                this.props.showError(error)
            }
        )
    }

    renderTable() {
        const { jobs, activeGroupByCustomer } = this.state

        if (activeGroupByCustomer) {
            return (
                <Row><Col><div style={{ overflowX: 'auto' }}><Table>
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th>Total Price</th>
                            <th>Actual Hours</th>
                            <th>$/hr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((job, i) => (
                            <tr key={i}>
                                <td>
                                    <a href={'/customerreport?company=' + encodeURIComponent(job.customer_name || '')}>
                                        {job.customer_name || '—'}
                                    </a>
                                </td>
                                <td>{formatMoney(job.total_price)}</td>
                                <td>{job.actual_hours > 0 ? parseFloat(job.actual_hours).toFixed(1) : '—'}</td>
                                <td>{job.price_per_hour != null ? formatMoney(job.price_per_hour, 0) : '—'}</td>
                            </tr>
                        ))}
                        {jobs.length === 0 &&
                            <tr><td colSpan="4" className="text-center">No jobs found</td></tr>
                        }
                    </tbody>
                </Table></div></Col></Row>
            )
        }

        return (
            <Row><Col><div style={{ overflowX: 'auto' }}><Table>
                <thead>
                    <tr>
                        <th>Job Name</th>
                        <th>Customer</th>
                        <th>Shipped Date</th>
                        <th>Total Price</th>
                        <th>Actual Hours</th>
                        <th>$/hr</th>
                    </tr>
                </thead>
                <tbody>
                    {jobs.map((job) => (
                        <tr key={job.id}>
                            <td>
                                <a href={'/quote/' + job.id}>
                                    {job.job_name || '(no name)'}
                                </a>
                            </td>
                            <td>
                                <a href={'/customerreport?company=' + encodeURIComponent(job.customer_name || '')}>
                                    {job.customer_name || '—'}
                                </a>
                            </td>
                            <td>{job.shipped_date ? String(job.shipped_date) : '—'}</td>
                            <td>{formatMoney(job.total_price)}</td>
                            <td>{job.actual_hours > 0 ? parseFloat(job.actual_hours).toFixed(1) : '—'}</td>
                            <td>{job.price_per_hour != null ? formatMoney(job.price_per_hour, 0) : '—'}</td>
                        </tr>
                    ))}
                    {jobs.length === 0 &&
                        <tr><td colSpan="6" className="text-center">No jobs found</td></tr>
                    }
                </tbody>
            </Table></div></Col></Row>
        )
    }

    render() {
        const { from, to, jobNameSearch, customerSearch, groupByCustomer } = this.state

        return (
            <Container>
                <h3 style={{ marginTop: '20px', marginBottom: '16px' }}>Job Cost</h3>

                <Row className="align-items-end mb-3 g-2">
                    <Col xs="auto">
                        <FormGroup>
                            <Label style={{ fontSize: '0.85rem', marginBottom: '2px' }}>From</Label>
                            <Input
                                type="date"
                                value={from}
                                onChange={(e) => this.setState({ from: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="auto">
                        <FormGroup>
                            <Label style={{ fontSize: '0.85rem', marginBottom: '2px' }}>To</Label>
                            <Input
                                type="date"
                                value={to}
                                onChange={(e) => this.setState({ to: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="auto">
                        <FormGroup>
                            <Label style={{ fontSize: '0.85rem', marginBottom: '2px' }}>Job Name</Label>
                            <Input
                                type="text"
                                placeholder="Search job name..."
                                value={jobNameSearch}
                                disabled={groupByCustomer}
                                onChange={(e) => this.setState({ jobNameSearch: e.target.value })}
                                onKeyDown={(e) => e.key === 'Enter' && this.handleSearch()}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="auto">
                        <FormGroup>
                            <Label style={{ fontSize: '0.85rem', marginBottom: '2px' }}>Customer</Label>
                            <Input
                                type="text"
                                placeholder="Search customer..."
                                value={customerSearch}
                                onChange={(e) => this.setState({ customerSearch: e.target.value })}
                                onKeyDown={(e) => e.key === 'Enter' && this.handleSearch()}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="auto">
                        <FormGroup check style={{ marginTop: '28px' }}>
                            <Input
                                type="checkbox"
                                checked={groupByCustomer}
                                onChange={(e) => this.setState({ groupByCustomer: e.target.checked })}
                            />
                            <Label check>Group by Customer</Label>
                        </FormGroup>
                    </Col>
                    <Col xs="auto">
                        <FormGroup>
                            <Label style={{ fontSize: '0.85rem', marginBottom: '2px' }}>&nbsp;</Label>
                            <div>
                                <Button color="primary" onClick={this.handleSearch}>
                                    Search
                                </Button>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>

                {this.renderTable()}
            </Container>
        )
    }
}

export default JobCostViewController
